"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _underscore = _interopRequireDefault(require("underscore"));

var _backbone = _interopRequireDefault(require("backbone"));

var _handlebars = _interopRequireDefault(require("handlebars"));

var _config = _interopRequireDefault(require("config"));

var _AddToCalendarView = _interopRequireDefault(require("./AddToCalendarView"));

var _ContactOrganizerView = _interopRequireDefault(require("./ContactOrganizerView"));

var _site_footer = _interopRequireDefault(require("hbars!../templates/site_footer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterView = _backbone.default.View.extend({
  events: {
    'click .js-contact-organizer-action': 'onContactOrganizerClicked',
    'click [data-id=gdpr_link]': function clickDataIdGdpr_link() {
      return window._sp_.gdpr.loadPrivacyManagerModal(796473);
    },
    'click [data-id=ccpa_link]': function clickDataIdCcpa_link() {
      return window._sp_.ccpa.loadPrivacyManagerModal(795963);
    },
    'consentReady': 'onConsentReady'
  },
  initialize: function initialize(options) {
    options = options || {};
    this.event = options.event;
    this.addToCalendarView = new _AddToCalendarView.default({
      event: this.event
    });
    this.contactOrganizerPopup = new _ContactOrganizerView.default();
    this.model.set('internalWebsiteBaseUrl', this.event.getInternalWebsiteBaseUrl());
    this.model.set('isCookieConsentEnabled', options.isCookieConsentEnabled);
    window.__isFooterInitialized = true;
  },
  remove: function remove() {
    this.addToCalendarView.remove();
    this.contactOrganizerPopup.remove();
    return _backbone.default.View.prototype.remove.call(this);
  },
  onContactOrganizerClicked: function onContactOrganizerClicked() {
    this.contactOrganizerPopup.show();
  },
  onConsentReady: function onConsentReady(event) {
    var originalEvent = event.originalEvent;
    var _originalEvent$detail = originalEvent.detail,
        isGdprApplies = _originalEvent$detail.isGdprApplies,
        isCcpaApplies = _originalEvent$detail.isCcpaApplies;
    this.model.set({
      isGdprApplies: isGdprApplies
    });
    this.model.set({
      isCcpaApplies: isCcpaApplies
    });
    this.render();
  },
  render: function render() {
    var html = (0, _site_footer.default)(this.model.toJSON());
    this.$el.html(html);
    this.$('.add-to-calendar').html(this.addToCalendarView.render().el);
    return this;
  }
});

var _default = FooterView;
exports.default = _default;